import { jsx } from "react/jsx-runtime";
import { Text } from "@nxt-costco-com/forge-components";
const LinkText = ({
  entry
}) => {
  if (!entry.link.title) return null;
  return /* @__PURE__ */ jsx(
    Text,
    {
      bold: entry.link_style === "bold",
      italic: entry.link_style === "italic",
      uniqueId: entry.link.title,
      children: entry.link.title
    }
  );
};
export {
  LinkText
};
